<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col class="">
        <h1 class="justify-center text-center display-3 my-8">Presenting: The Space Rocket Drop</h1>

        <p class="body-1">
          The Space Rocket drop represents the first NFT collection on Cardano with full support and compatibility with the
          Adosia Space Printer 3D marketplace.
        </p>
        <p class="body-1">
          Each of the 5,000 unique NFTs available includes: An AR-compatible, 3D GLB file, a transparent PNG, a JPG
          thumbnail, plus a complete bill of materials including colors, quantities, and STL files for 3D printing your
          rocket at home or via the Adosia Space Printer Distributed 3D Manufacturing network!
        </p>
        <p class="body-2">
          <strong>Note:</strong> 3D Printing and fulfillment via the Adosia Space Printer network will be available as a
          separate charge and should be available in Q1 2023!
        </p>
        <h2 class="justify-center text-center display-1 my-8">Three Ways to Pay</h2>
        <v-row>
          <v-col cols="12" md="4">
            <v-card class="text-center">
              <v-card-title class="justify-center">Pay with ADA</v-card-title>
              <v-card-text>Price: 100 &#8371;</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card class="text-center">
              <v-card-title class="justify-center">Pay with ADA + ADO</v-card-title>
              <v-card-text>Price: 50 &#8371; + 5k ADO</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card class="text-center">
              <v-card-title class="justify-center">Pay with ADA + spacecoins</v-card-title>
              <v-card-text>Price: 50 &#8371; + 5k spacecoins</v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-alert color="blue" type="info" border="left" class="my-4" v-if="remaining < 500 && remaining > 0">
          Less than 500 remaining!
        </v-alert>
        <v-alert color="red" type="info" border="left" class="my-4" v-if="remaining <= 0">
          SOLD OUT! Thank you to all who participated in our first Adosia 3D NFT drop!
        </v-alert>
      </v-col>
      <v-col class="text-center" cols="12" md="4">
        <v-img :src="require('../assets/rocket_sample.jpg')" contain max-width="512" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AboutDrop",
  props: ['remaining','pubsale','pubsale_start'],
}
</script>

<style scoped>

</style>